import './styles.sass';

import React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';

import PublicationStatusFlags from 'components/Shared/PublicationStatusFlags';
import ResearchOutput from 'components/Explorer/models/research_output';
import { aiFeaturesEnabled } from 'models/ai_features';
import * as QueryParams from 'components/Explorer/models/query_params';
import useQueryParams from 'hooks/useQueryParams';
import Sentiment from './Sentiment';

const Output = ({ post, output }) => {
  const location = useLocation();
  const params = useQueryParams();

  const detailsLocation = {
    pathname: location.pathname,
    search: QueryParams.searchFor(QueryParams.withShowDetails(params, output.id))
  };

  const showSentimentSwatch = aiFeaturesEnabled() && (post.postType === 'bluesky' || post.postType === 'tweet');

  return (
    <div className="Mentions-Output">
      <Link to={detailsLocation}>
        <div className="badge">
          <img
            src={output.badgeUrl}
            loading="lazy"
            width="50"
            height="50"
            alt={I18n.t('Explorer.Mentions.badge.alt', { score: output.score })}
          />
          {output.verified && (
            <div className="verified-badge" data-testid="verified-badge">
              <div
                className="icon"
                role="img"
                aria-label={I18n.t('Explorer.Outputs.ResearchOutputItem.verified', {
                  name: window.current_user.institution_name
                })}
                title={I18n.t('Explorer.Outputs.ResearchOutputItem.verified', {
                  name: window.current_user.institution_name
                })}
              />
            </div>
          )}
        </div>
      </Link>
      <div>
        <Link to={detailsLocation} className="title">
          <PublicationStatusFlags output={output} />
          <span className="main">{output.title}</span>
          <span className="source">{output.meta}</span>
        </Link>
        {showSentimentSwatch && <Sentiment output={output} post={post} />}
      </div>
    </div>
  );
};

Output.propTypes = {
  post: PropTypes.object.isRequired,
  output: PropTypes.instanceOf(ResearchOutput).isRequired
};

export default Output;
